import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/icons/nested-grid.svg'


const _hoisted_1 = {
  key: 0,
  class: "map-details"
}
const _hoisted_2 = { class: "flex-row flex-space width-100" }
const _hoisted_3 = { class: "map-details__tab m-0" }
const _hoisted_4 = { class: "map-details__actions flex-row ml-16" }
const _hoisted_5 = { class: "mt-12 flex-row" }
const _hoisted_6 = { class: "map-details__subgrid-info flex-row items-center" }
const _hoisted_7 = {
  key: 0,
  class: "map-details__subgrid-info-icon",
  src: _imports_0,
  alt: "Nested grid"
}
const _hoisted_8 = { class: "map-details__body" }
const _hoisted_9 = {
  key: 0,
  class: "map-details__empty-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_map_download_dropdown = _resolveComponent("map-download-dropdown")!
  const _component_c_button_icon = _resolveComponent("c-button-icon")!
  const _component_c_toggle = _resolveComponent("c-toggle")!
  const _component_map_chart = _resolveComponent("map-chart")!

  return (_openBlock(), _createBlock(_Transition, { name: "fly-in" }, {
    default: _withCtx(() => [
      (_ctx.visibility)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h3", _hoisted_3, [
                _createElementVNode("span", null, _toDisplayString(_ctx.chartTitle), 1)
              ]),
              _createElementVNode("div", _hoisted_4, [
                (!_ctx.hasNoCsvData)
                  ? (_openBlock(), _createBlock(_component_map_download_dropdown, {
                      key: 0,
                      "button-icon-type": _ctx.ButtonIconType.FLAT,
                      "button-icon-color": _ctx.ButtonIconColor.SECONDARY,
                      "hide-animation": true,
                      "shadow-root": _ctx.shadowRoot,
                      onDownloadImage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onDownloadImage())),
                      onDownloadPDF: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDownloadPDF())),
                      onDownloadFile: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onDownloadFile()))
                    }, null, 8, ["button-icon-type", "button-icon-color", "shadow-root"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_c_button_icon, {
                  "icon-name": _ctx.faTimes.iconName,
                  type: _ctx.ButtonIconType.FLAT,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setVisibility(false)))
                }, null, 8, ["icon-name", "type"])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_c_toggle, {
                "model-value": _ctx.showSubgrid,
                label: _ctx.$t('mapDetails.subgridToggleLabel'),
                disabled: _ctx.subgridDisabled,
                "onUpdate:modelValue": _ctx.onToggleSubgrid
              }, null, 8, ["model-value", "label", "disabled", "onUpdate:modelValue"]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", null, _toDisplayString(_ctx.showSubgrid ? _ctx.$t('mapDetails.subgridToggleOffInfo') : _ctx.$t('mapDetails.subgridToggleOnInfo')), 1),
                (!_ctx.showSubgrid)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                (_ctx.hasNoCsvData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('mapDetails.noCsvData')), 1)
                    ]))
                  : (_ctx.datasets && _ctx.visibility)
                    ? (_openBlock(), _createBlock(_component_map_chart, {
                        key: 1,
                        filters: _ctx.filters,
                        dataset: _ctx.datasets,
                        title: _ctx.chartTitle,
                        "y-label": _ctx.yLabel,
                        "shadow-root": _ctx.shadowRoot,
                        onChartUpdated: _ctx.onChartUpdated
                      }, null, 8, ["filters", "dataset", "title", "y-label", "shadow-root", "onChartUpdated"]))
                    : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}